import React, { useEffect, useRef, useState, useMemo } from "react";
import { CommonService } from "../../Service/CommonService";
import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Tooltip, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoIcon from "@mui/icons-material/Info";
import { useLocation, useHistory, useParams } from "react-router";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import EditIcon from '@mui/icons-material/Edit';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RestoreIcon from '@mui/icons-material/Restore';
import ContainerTimeLineOverlay from "./ContainerTimeLineOverlay";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { InventoryApiService } from "../../Service/InventoryApiService";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ContainerImage from '../../assets/images/products/WhiskyBarrelBig.png'

import barrel_1_2_a from '../../assets/images/facilities_images/1-2/1_2_a.png';
import barrel_2_3_a from '../../assets/images/facilities_images/2-3/2_3_a.png';
import barrel_3_4_a from '../../assets/images/facilities_images/3-4/3_4_a.png';
import barrel_4_5_a from '../../assets/images/facilities_images/4-5/4_5_a.png';
import barrel_5_6_a from '../../assets/images/facilities_images/5-6/5_6_a.png';
import barrel_6_7_a from '../../assets/images/facilities_images/6-7/6_7_a.png';
import barrel_7_8_a from '../../assets/images/facilities_images/7-8/7_8_a.png';
import barrel_8_9_a from '../../assets/images/facilities_images/8-9/8_9_a.png';
import barrel_9_10_a from '../../assets/images/facilities_images/9-10/9_10_a.png';
import barrel_10_11_a from '../../assets/images/facilities_images/10-11/10_11_a.png';
import barrel_11_12_a from '../../assets/images/facilities_images/11-12/11_12_a.png';
import barrel_12_13_a from '../../assets/images/facilities_images/12-13/12_13_a.png';
import barrel_13_14_a from '../../assets/images/facilities_images/13-14/13_14_a.png';
import barrel_14_15_a from '../../assets/images/facilities_images/14-15/14_15_a.png';
import barrel_15_16_a from '../../assets/images/facilities_images/15-16/15_16_a.png';
import barrel_16_17_a from '../../assets/images/facilities_images/16-17/16_17_a.png';
import barrel_17_18_a from '../../assets/images/facilities_images/17-18/17_18_a.png';
import barrel_18_19_a from '../../assets/images/facilities_images/18-19/18_19_a.png';
import barrel_19_20_a from '../../assets/images/facilities_images/19-20/19_20_a.png';
import barrel_20_21_a from '../../assets/images/facilities_images/20-21/20_21_a.png';
import barrel_21_22_a from '../../assets/images/facilities_images/21-22/21_22_a.png';
import barrel_22_23_a from '../../assets/images/facilities_images/22-23/22_23_a.png';
import barrel_23_24_a from '../../assets/images/facilities_images/23-24/23_24_a.png';
import barrel_24_25_a from '../../assets/images/facilities_images/24-25/24_25_a.png';
import barrel_25_plus_a from '../../assets/images/facilities_images/25_plus/25_plus_a.png';
import DataGridLoader from "../Common/DataGridLoader";

const ContainerDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const history = useHistory();
    const [showContainerTimeline, setShowContainerTimeline] = useState(false);
    const [showContainerHistory, setShowContainerHistory] = useState(false);
    const [rows, setRows] = React.useState([]);
    const [sortModel, setSortModel] = React.useState([]);
    const [searchText, setSearchText] = React.useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [sortField, setSortField] = useState("createdDate"); 
    const [sortDirection, setSortDirection] = useState("desc");
    const [totalCount, setTotalCount] = useState(0);
    const [filter, setFilter] = useState<any>({valuation: null, updatedAt: null, creadtedBy: null});
    const [barrelData, setBarrelData] = useState<any>({});
    const [selectedId, setSelectedId] = useState(null);
    const [liquidHistoryData, setLiquidHistoryData] = useState<any[]>([]);
    const location = useLocation<{ barrelNumber?: any, lotNo?: any }>();
    const barrelNumber = location.state?.barrelNumber;
    const lotNo = location.state?.lotNo;
    
    const routeBack = () => {
        history.goBack();
    };
   
    useEffect(() => {
        fetchData();
      }, []);
    
    const fetchData = async () => {
        try {
            const response = await InventoryApiService.getContainerBarrelDetailsById(id);
            setBarrelData(response.data);
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    const getContainerRequestMappingHistoryDetails = async (barrelId, page, pageSize, sortField: any, sortDirection: any, filter: any) => {        
        try {
            const controller = new AbortController();
            const signal = controller.signal;
            
            const response = await InventoryApiService.getContainerRequestMappingHistoryDetails(barrelId, barrelNumber, lotNo, page, pageSize, sortField, sortDirection, filter, signal);
            setLiquidHistoryData(response.data.content);
            setTotalCount(response.data.totalElements);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };
    
    const handleTimelineClick = (id) => {
        setSelectedId(id);
        setShowContainerTimeline(true);
  setShowContainerHistory(false);
    };

    const handleHistoryClick = (id) => {
        setSelectedId(id);
        setShowContainerTimeline(false)
        setShowContainerTimeline(false);
        setShowContainerHistory(prev => {
            const next = !prev;
            if (next) {
                getContainerRequestMappingHistoryDetails(id, page, pageSize, sortField, sortDirection, filter);
            }
            return next;
        });
    };

    const handleEditBarrelClick = (id:any) => {
        const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
        history.push(`${linkPrefix}/edit-barrel/${id}`);
    }

    const onPaginationModelChange = (newPaginationModel) => {
        setPage(newPaginationModel.page);
        setPageSize(newPaginationModel.pageSize);

        getContainerRequestMappingHistoryDetails(id, newPaginationModel.page, newPaginationModel.pageSize, sortField, sortDirection, filter);
    };

    const handleSortChange = (sortModel) => {
        if (sortModel.length > 0) {
            const newSortField = sortModel[0].field;
            const newSortDirection = sortModel[0].sort; // "asc" or "desc" directly from DataGrid
            
            setSortField(newSortField);
            setSortDirection(newSortDirection);

            getContainerRequestMappingHistoryDetails(id, page, pageSize, sortField, sortDirection, filter);
            
        }
    };

    const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, field: keyof any) => {
        const value = event.target.value;

        // Prepare a temporary filter object with the updated field value
        const tempFilter = {
            ...filter,
            [field]: value,
        };

        // Update the filter state
        setFilter(tempFilter);

        getContainerRequestMappingHistoryDetails(id, page, pageSize, sortField, sortDirection, filter);
    };

    const CellWithTooltip = ({ value }: { value: string | number }) => {
        return (
            <Tooltip arrow title={value?.toString()}>
                <span>{value?.toString()}</span>
            </Tooltip>
        );
    };
    
    const BarrelImage = ({ fillDate }: { fillDate: string }) => {
        const { years, months } = CommonService.calculateAge(fillDate);
        const ageInYears = Number(years) + Number(months || 0) / 12;
    
        const getAgeIndex = (age: number) => {
          const years = Math.floor(age);
          if (years >= 25) return barrelImages.length - 1;
          if (years <= 1) return 0;
          return years - 1;
        };
    
        const selectedImage = useMemo(() => {
          const ageIndex = getAgeIndex(ageInYears);
          const images = barrelImages[ageIndex] || barrelImages[0];
          return images[Math.floor(Math.random() * images.length)];
        }, [ageInYears]);
    
        return <img src={selectedImage} alt="WhiskyBarrelBig" />;
    };

    const barrelImages = [
        [barrel_1_2_a],[barrel_2_3_a],[barrel_3_4_a],[barrel_4_5_a],[barrel_5_6_a],
        [barrel_6_7_a],[barrel_7_8_a],[barrel_8_9_a],[barrel_9_10_a],[barrel_10_11_a],
        [barrel_11_12_a],[barrel_12_13_a],[barrel_13_14_a],[barrel_14_15_a],[barrel_15_16_a],
        [barrel_16_17_a],[barrel_17_18_a],[barrel_18_19_a],[barrel_19_20_a],[barrel_20_21_a],
        [barrel_21_22_a],[barrel_22_23_a],[barrel_23_24_a],[barrel_24_25_a],[barrel_25_plus_a],
    ];
    
    const tableDataWithIds = liquidHistoryData.map((rowData, index) => ({
        ...rowData,
    }));

    const columns: GridColDef[] = [
        {
            field: "requestNumber",
            headerName: "Request #",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "180px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                            value={filter.requestNumber}
                            onChange={(event) => handleFilterChange(event, "requestNumber")}
                            onClick={(event) => event.stopPropagation()}
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
        },
        {
            field: "requestName",
            headerName: "Request/Action Name",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "180px" }}>
                        <input
                            type="text"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                            value={filter.requestName}
                            onChange={(event) => handleFilterChange(event, "requestName")}
                            onClick={(event) => event.stopPropagation()}
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
        },
        {
            field: "createdDate",
            headerName: "Timestamp",
            headerClassName: "table-header border-0 my-2 h-100",
            flex: 1,
            sortable: true,

            renderCell: (params) => <CellWithTooltip value={params.value} />,

            valueGetter: (value: any, row: any) => {
                const dateTimeString = row.createdDate ? row.createdDate : null;

                // reuse your common formatter
                if (dateTimeString) {
                    return CommonService.formatDateTime(dateTimeString);
                }

                return "-";
            },

            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "180px" }}>
                        <input
                            type="date"
                            className="form-control border mt-1"
                            style={{ boxShadow: "none" }}
                            name="createdDate"
                            value={filter.createdDate || ""}
                            onChange={(event) =>
                                handleFilterChange(event, "createdDate")
                            }
                            onClick={(event) => event.stopPropagation()}
                        />
                    </div>
                </div>
            )
        },
        {
            field: "createdBy",
            headerName: "Modified By",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "180px" }}>
                        <input
                            type="text"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                            value={filter.createdBy}
                            onChange={(event) => handleFilterChange(event, "createdBy")}
                            onClick={(event) => event.stopPropagation()}
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),

        },
        {
            field: "View Modified Details",
            headerName: "View Modified Details",
            flex: 1,
            minWidth: 200,
            sortable: false,
            disableColumnMenu: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params) => {
                const requestId = params.row.customerServiceRequestId;
                const containerId = params.row.barrelId;
                const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";

                const handleClick = () => {
                    if (requestId) {
                        history.push(
                            `${linkPrefix}/view-customer-service-request/${requestId}`
                        );
                    } else {
                        history.push(
                            `${linkPrefix}/container-history-detail/${containerId}`
                        );
                    }
                };

                return (
                    <Tooltip
                        title={requestId ? "View Request" : "View Container History"}
                        arrow
                    >
                        <IconButton
                            aria-label="view"
                            size="small"
                            onClick={handleClick}
                        >
                            <RemoveRedEyeOutlinedIcon
                                color={requestId ? "primary" : "disabled"}
                            />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];

    return (
        <>
            <div
                className="usersList usersList__user ProductDetail container-detail"
                style={{ paddingBottom: CommonService.isAdmin() ? 47 : "" }}
            >
                <div className="usersList__header--wrapper d-flex flex-wrap align-items-center w-100">
                    <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2 position-relative">
                        <div className="d-flex align-items-center gap-2 flex-wrap left-wrapper">
                            {CommonService.isAdmin() && (
                                <>
                                    <div className="back__button" onClick={routeBack}>

                                        <IconButton
                                            aria-label="ArrowBackIcon"
                                            sx={{ backgroundColor: "#FFF" }}
                                        >
                                            <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                                        </IconButton>
                                    </div>

                                    <div className="header--title">
                                        <h1 className="title mb-0">
                                           {showContainerHistory && !showContainerTimeline ? ( "Container Liquid History") : ( "Container Details")}
                                        </h1>
                                    </div>
                                    <div className="divider mx-2"></div>
                                </>
                            )}
                             {CommonService.isAdmin() && !barrelData?.khBarrelId &&  <button title="Edit Container"
                                className="primary-btn d-inline-flex align-items-center me-1 py-2"
                                style={{ paddingTop: "4px", paddingLeft: 11 }}
                                onClick={() => handleEditBarrelClick(id)}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "8px" }}>
                                    <mask id="mask0_15627_69860" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                        <rect width="24" height="24" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_15627_69860)">
                                        <path d="M2 24V20H22V24H2ZM6 16H7.4L15.2 8.225L13.775 6.8L6 14.6V16ZM4 18V13.75L15.2 2.575C15.3833 2.39167 15.5958 2.25 15.8375 2.15C16.0792 2.05 16.3333 2 16.6 2C16.8667 2 17.125 2.05 17.375 2.15C17.625 2.25 17.85 2.4 18.05 2.6L19.425 4C19.625 4.18333 19.7708 4.4 19.8625 4.65C19.9542 4.9 20 5.15833 20 5.425C20 5.675 19.9542 5.92083 19.8625 6.1625C19.7708 6.40417 19.625 6.625 19.425 6.825L8.25 18H4Z" fill="white" />
                                    </g>
                                </svg>

                                <span style={{ marginTop: "-2.7px" }}>
                                    Edit Container
                                </span>
                            </button>}
                            {/*<button title="Generate Report"
                                className="primary-btn d-inline-flex align-items-center me-1"
                                style={{ paddingTop: "4px", paddingLeft: 11 }}
                            >
                                <FileDownloadOutlinedIcon sx={{ marginTop: "2.5px", marginRight: "8px", height: "24px", width: "24px" }} />
                                Generate Report
                            </button>*/}
                        </div>
                        <div className="d-flex align-items-center gap-3">
                            <Tooltip arrow title="Container Liquid Timeline">
                            <IconButton
                                aria-label="ArrowBackIcon"
                                sx={{
                                    backgroundColor: showContainerTimeline ? "#97AEB8" : "#F8F9FA",
                                    mb: 1,
                                    "&:hover": { backgroundColor: "#97AEB8" },
                                }}
                                onClick={() => handleTimelineClick(id)}
                            >
                                <HourglassEmptyIcon sx={{  color: showContainerTimeline ? "#ffffff" : "#000000", "&:hover": { color: "#ffffff" } }} />
                            </IconButton>
                            </Tooltip>
                            <Tooltip arrow title="Container Liquid History">
                            <IconButton
                                aria-label="ArrowBackIcon"
                                sx={{
                                    backgroundColor: showContainerHistory ? "#97AEB8" : "#F8F9FA",
                                    mb: 1,
                                    "&:hover": { backgroundColor: "#97AEB8" },
                                }}
                                onClick={() => handleHistoryClick(id)}
                            >
                                <RestoreIcon sx={{ color: showContainerHistory ? "#ffffff" : "#000000", "&:hover": { color: "#ffffff" } }} />
                            </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className="user-table-container position-relative">
                    <div className={`userTable ${showContainerHistory ? "userTable-data" : ""}`}>
                        {showContainerHistory && !showContainerTimeline ? (
                            <>
                                <DataGrid
                                    className="data-grid data-grid__myinventories support-req--listing p-0"
                                    rows={tableDataWithIds}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page, pageSize },
                                        },
                                    }}
                                    pagination
                                    paginationModel={{ page, pageSize }}
                                    onPaginationModelChange={onPaginationModelChange}
                                    onSortModelChange={handleSortChange}
                                    rowCount={totalCount}
                                    paginationMode="server"
                                    sortingMode="server"
                                    pageSizeOptions={[10, 20, 50, 100]}
                                    loading={isLoading}
                                    slots={{
                                        loadingOverlay: DataGridLoader,
                                    }}
                                    disableRowSelectionOnClick
                                    disableColumnResize
                                />
                            </>
                        ):
                        (
                            <div className='detail-inner'>
                            <div className="row d-flex mb-5">
                                <div className="col-12 col-lg-4 mb-5 mb-lg-0">
                                    <div className="product__img d-flex justify-content-center">
                                        <BarrelImage fillDate={barrelData?.fillDate} />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-8">
                                    <div className="product__info">
                                        <div className="header">
                                            <h2>{barrelData?.productName ?? "-"}</h2>
                                        </div>
                                        <div className="product-info-body">
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <div className="table-responsive">
                                                        <Table>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Container Id
                                                                    </TableCell>
                                                                    <TableCell>
                                                                          {barrelData?.barrelNumber ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        LOT #
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.lotNo ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Container Cost
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.barrelCost ? `$${barrelData.barrelCost}` : "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Sell Cost
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.sellCost ? `$${barrelData.sellCost}` : "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Insurance Value
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.insuranceValue ? `$${barrelData.insuranceValue}` : "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        PRODUCER
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.producer ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Mash bill
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.mashBill ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Mash bill Description
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.mashBillDescription ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        TTB TYPE
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.ttbType ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        TTB CLASS
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.ttbClass ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        FILL DATE
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.fillDate ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Facility
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.facility ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Container Size
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.barrelSize ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Volume
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.volume ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        Proof
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.proof ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Description</TableCell>
                                                                    <TableCell>
                                                                        {barrelData?.description ? (
                                                                            <div
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: barrelData.description
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="table-responsive">
                                                        <Table>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        PROOF GALLONS
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.proofGallons ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        WAREHOUSE
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.rackhouse ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        ROW
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.row ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        DEPTH
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.depth ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        HEIGHT
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.height ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        TOTAL LOT PG
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.totalLotPg ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        DSP
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.dsp ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        STAGE
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.stage ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        LOCATION
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.location ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        STATE
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.state ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        COUNTRY
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.country ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        CONTAINER STATUS
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.barrelStatus ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        CONTAINER TYPE
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.containerType ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        CONTAINER HEALTH
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.containerHealth ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>                                                                
                                                                <TableRow>
                                                                    <TableCell>
                                                                        WHITEDOG MANAGED
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.isManagedByWhitedog ? "Yes" : "No"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        STAGING AREA
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {barrelData.stagingArea ?? "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    }
                    </div>
                    { showContainerTimeline && !showContainerHistory && (<ContainerTimeLineOverlay id={selectedId} onClose={() => setShowContainerTimeline(false)} />)}
                </div>
            </div>
        </>
    )
};

export default ContainerDetail;
